import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import type MapLocation from '@alltrails/amplitude/enums/MapLocation';
import type TrailCardLocation from '@alltrails/amplitude/enums/TrailCardLocation';
import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import TrailResults from '@alltrails/maps/components/TrailResults/TrailResults';
import useTrailNavigate, { useExploreTrailUrl } from '@/hooks/useTrailNavigate';
import { useLogExploreCardViewed } from '@/utils/analyticsHelpers';
import { useAppSelector } from '@/utils/redux';

type Props = {
  handleFavoriteClick?: (trailId: number) => void;
  cardLocation?: TrailCardLocation;
  detailedCardLocation?: CardLocation;
  mapLocation?: MapLocation | string;
};

const TrailResultsMapComponents = ({
  handleFavoriteClick,
  cardLocation = 'explore map view',
  detailedCardLocation = 'explore tab map view',
  mapLocation = PageStrings.EXPLORE_ALL_PAGE
}: Props) => {
  const logExploreCardViewed = useLogExploreCardViewed('trail');
  const onTrailNavigate = useTrailNavigate();
  const getExploreTrailUrl = useExploreTrailUrl();
  const activityType = useAppSelector(state => state.exploreService.filters?.activity?.[0]);

  return (
    <TrailResults
      activityType={activityType}
      cardLocation={cardLocation}
      detailedCardLocation={detailedCardLocation}
      mapLocation={mapLocation}
      onTrailCardViewed={logExploreCardViewed}
      onTrailNavigate={onTrailNavigate}
      getTrailCardUrl={getExploreTrailUrl}
      handleFavoriteClick={handleFavoriteClick}
    />
  );
};

export default TrailResultsMapComponents;
